if (window.document.documentMode) {
  location.href = "/pages/unsupported_browser";
}

// let userAgent = window.navigator.userAgent.toUpperCase();
 
// if (userAgent.indexOf('MSIE') === -1 && userAgent.indexOf('TRIDENT') === -1) {
// } else {
//   // IEでアクセス
//   location.href = "/pages/unsupported_browser";
// }